import ReactGA from 'react-ga4';
import { isEmpty } from 'lodash';
import { getHostedPageFlowType, isIframe } from 'utilities/global';
import { GaDimensionNaming } from 'consts';

export const trackingIds = {
  checkout: 'G-GFG20LZYXP',
  beneficiary_tokenization: 'G-TKKZ5LB0BV',
  card_tokenization: 'G-DX0KPDY2FG',
  card_issuing: 'G-HWPGSLDT9X',
  idv: 'G-C4HQ21H4FF',
  card_issuing_activate: 'G-Y49Y104CZ9',
  card_issuing_pin: 'G-1YM3CQL89K',
  subscription: 'G-2XCVSQ3S1W',
  reusable_link: 'G-EH9DGND6QD',
  payout_tracker: 'G-96M3SXZX0C',
  demo: 'G-1W8PGDBDFG'
};

export const initGoogleAnalytics = data => {
  const hostedPageType = getHostedPageFlowType();

  const cookieProps = {
    cookieDomain: 'none',
    cookieFlags: 'samesite=none;secure'
  };
  const analyticsOptions = {
    alwaysSendToDefaultTracker: false,
    anonymizeIp: true
  };

  const {
    merchant_alias: merchantAlias,
    org_id: merchantId,
    category,
    kwp_valitor_additional_data: kwpVwpData
  } = data || {};
  const integrationType = isIframe() ? 'Toolkit' : 'Redirect';
  const { MERCHANT_NAME, MERCHANT_ID, INTEGRATION_TYPE, PAYOUT_CATEGORY, IS_VALITOR } =
    GaDimensionNaming;

  if (trackingIds?.[hostedPageType]) {
    ReactGA.initialize(trackingIds[hostedPageType], {
      ...analyticsOptions,
      gaOptions: {
        name: hostedPageType,
        [MERCHANT_NAME]: merchantAlias,
        [MERCHANT_ID]: merchantId,
        [INTEGRATION_TYPE]: integrationType,
        [IS_VALITOR]: !isEmpty(kwpVwpData),
        ...(category ? { [PAYOUT_CATEGORY]: category } : {}),
        ...cookieProps
      }
    });
  }
};

export default initGoogleAnalytics;
